import React, { PropTypes } from 'react';
import _ from 'lodash';
import cx from 'classnames';

import Input from 'components/forms/Input';

import { CopyIconButton } from 'components/Button';


// ====================
// INPUT TEXT
// ====================
class CopyInput extends React.Component {
  _inputRef = null
  onInputRef = node => this._inputRef = node

  onCopyClick = (e) => {
    let { text } = this.props;
    this._inputRef.getInput()?.select();
    document.execCommand('copy');
    this._inputRef.getInput()?.focus();
  }

  onFocus = () => {
    this._inputRef.getInput()?.select();
  }
  
  render() {
    let { type = 'text', className, ...props } = this.props;
    return (
      <Input
        {...props}
        ref={this.onInputRef}
        className={cx("text with-copy", className)}
        readOnly={true}
        onFocus={this.onFocus}
        renderInput={inputProps => (
        <>
          <input type={type} {...inputProps} />
          <CopyIconButton 
            size="m"
            onClick={this.onCopyClick} />
        </>)} />
    )
  }
}
export default CopyInput;
